/**
 * =========================================================================================
 * ATS Main component
 * =========================================================================================
 * Main routing (Organization) defined
 * Sub-routing defined
 *
 */

import React, {lazy, Suspense} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import NetworkDetector from "../common/HOCs/NetworkDetector";
import {NotAuthenticated} from "./candidate-portal/component/document-skelaton";
import {Error404} from "./common/error-page";
const JobListing = lazy(() => import('./job-listing'));
const JobDetails = lazy(() => import('./job-details'));
const JobApply = lazy(() => import('./job-apply'));
const InterviewQuestions = lazy(() => import('./interview-questions'));
const VerificationPublic = lazy(()=>import('./verification-survey'));
const AuthenticatePublic = lazy(()=>import("./candidate-portal"));
const CandidatePortal = lazy(()=>import("./candidate-portal/component"));
const InterviewFrom = lazy(() => import('./interview-form'));
const QuestionBankForm = lazy(()=>import("./question-bank"));

const AppATSPublic = () => {
    return (
        <React.Fragment>
            {/** Router setup using nesting route functionality */}
            <div className="u_ats u_relative u_ats-app-view">
                <Suspense fallback={<div>Loading...</div>}>
                    <Switch>
                        <Route path={`/job/listing`} component={JobListing}/>
                        <Route path={`/job/details/:jobId`} component={JobDetails}/>
                        <Route path={`/job/apply/:jobId`} component={JobApply}/>
                        <Route path={`/interview/:orgId/questions/:interviewId`} component={InterviewQuestions}/>
                        <Route path={`/:orgId/verification/:id`} component={VerificationPublic}/>
                        <Route exact path={`/sign/document/other/:id`} component={CandidatePortal}/>
                        <Route path={`/sign`} component={AuthenticatePublic}/>
                        <Route path={`/sign/document/not-authenticated/:id`} component={NotAuthenticated}/>
                        <Route path={`/interview-form/:candidateInfoId/:jobId`} component={InterviewFrom}/>
                        <Route exact path={`/evaluation/review/:id/:candidateId/:orgId/:submitId`} component={QuestionBankForm}/>
                        <Route exact path={`/evaluation/questions/:id/:candidateId/:orgId`} component={QuestionBankForm}/>
                        <Route exact path={`/job/:404`} component={Error404}/>
                        <Route exact path={`/interview/:404`} component={Error404}/>
                        <Route exact path={`/interview-form/:404`} component={Error404}/>
                        <Route exact path={`/evaluation/:404`} component={Error404}/>
                        <Route exact path="*" component={Error404}/>
                    </Switch>
                </Suspense>
            </div>
        </React.Fragment>
    );
};

export default NetworkDetector(AppATSPublic);
